module.exports = __webpack_public_path__ + "static/media/check_icon.350a4ff3.svg";